import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Popover,
    Form,
    Drawer,
    Card,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, dispatchtoast, filterOption, messageConfiguration } from "../../../utils";
//   import {
//     updateActivationStatus,
//   } from "./orderapiFunctions";
import { addRestro, getordersDetails, getBrand, restroDisabled, userRegister, getrestroList } from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"


const Brand = () => {

    const [orderData, setorderData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [VendorId, setVendorId] = useState(undefined);

    const [currentStatus, setCurrentStatus] = useState();
    const [loader, setloader] = useState(false);
    const [form] = Form.useForm();
    const handleChangeStatus = (id, status) => {
        setIsLoading(true);
        console.log(status);
        const newStatus = status == 1 ? 0 : 1; // Toggle status

        restroDisabled(`?restaurantId=${id}&isActive=${newStatus}`)
            .then((response) => {
                if (response.status) {
                    message.success("Status updated successfully");
                    setCurrentStatus(newStatus); // Update local state
                    FetchordersDetails();
                } else {
                    message.error("Failed to update status");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                message.error("An error occurred while updating the status");
                setIsLoading(false);
            });
    };

    const popoverContent = (id, status) => (
        <div>
            <p>Are you sure you want to change the status?</p>
            <Button
                type="primary"
                onClick={() => handleChangeStatus(id, status)}
                disabled={isLoading}
            >
                {isLoading ? <Spin size="small" /> : "Confirm"}
            </Button>
        </div>
    );

    const [isLoading, setIsLoading] = useState(false);
    const [addloader, setaddloader] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [vendorData, setVendorData] = useState([]);

    const [totalPages, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [action, setAction] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const { Search } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const from = location.state?.from;

    const handleFinish = (val) => {
        // Prepare the payload as a JSON object
        const payload = {
            mobile_number: val.mobile_number,
            email: val.email,
            name: val.name,
            password: val.password,
        };
        setaddloader(true);
        // Call the API with JSON data
        addRestro({
            "mobile_number": val.mobile_number,
            "email": val.email,
            "name": val.name,
            "address": val.address,
            "password": val.password,
            "commissionAmount": val.commissionAmount
        })
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message); // Display success message
                    setaddloader(false)
                    setOpenModal(false);
                    FetchordersDetails();
                }
                else {
                    setaddloader(true)
                }
            })
            .catch((err) => { console.error(err); setaddloader(false) }); // Handle error
    };


    const FetchordersDetails = (page) => {
        setIsLoading(true);
        getBrand(`?page=${page}&limit=5&search=${searchTerm}`)
            .then((response) => {
                if (response.status) {
                    setorderData(Array.isArray(response.data) ? response.data : []);
                    setCurrentPage(response.pagination.currentPage || 1);
                    setTotalPages(response.pagination.totalPages || 0);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching order details:", err);
                setIsLoading(false);
            });
    };
    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };

    // function changeActiveStatus(checked, record) {
    //   console.log(checked, record);
    //   const isDeleteAction = checked === undefined;

    //   let payload = {
    //     name: record.name,
    //     is_active: isDeleteAction ? (checked ? "1" : "0") : record.is_active,
    //     is_deleted: isDeleteAction ? "0" : "1",
    //   };

    //   updateActivationStatus(payload, record.id)
    //     .then((response) => {
    //       if (response.data.status === "success") {
    //         const updatedorderTable = orderData.map((item) =>
    //           item.id === record.id
    //             ? {
    //               ...item,
    //               is_active: isDeleteAction
    //                 ? item.is_active
    //                 : payload.is_active,
    //             }
    //             : item
    //         );
    //         setorderData(updatedorderTable);
    //         FetchordersDetails(currentPage);
    //         message.open(
    //           messageConfiguration(
    //             "success",
    //             isDeleteAction
    //               ? "Category deleted successfully."
    //               : response.message,
    //             3
    //           )
    //         );
    //         if (!isDeleteAction) {
    //           FetchordersDetails(currentPage);
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       message.open(
    //         messageConfiguration(
    //           "error",
    //           isDeleteAction
    //             ? "Failed to delete category."
    //             : "Failed to update status.",
    //           3
    //         )
    //       );
    //     });

    // }

    const handleErrorImage = (e) => {

        e.target.src = errorImage

    }
    // console.log("tottaaaaaaaaaaal", totalPage);
    const setwithdrawAction = (id, value) => {
        setAction((prevAction) => ({
            ...prevAction,
            [id]: value,
        }));
    };

    const FetchVendorsDetails = (page) => {
        getrestroList()
            .then((response) => {
                if (response.status) {
                    setVendorData(
                        response.data.map((i) => ({
                            label: i.name,
                            value: i.id,
                        }))
                    );

                    // setVendorData(response.data?.vendor || []);
                }
            })
            .catch((err) => {
                console.error("Error fetching vendor details:", err);
            });
    };

    useEffect(() => {
        FetchordersDetails(currentPage);
    }, [currentPage, searchTerm]);

    const handleDrawerClose = () => {
        setOpenModal(false);
    };


    useEffect(() => {
        FetchordersDetails(currentPage);
        FetchVendorsDetails();
    }, [currentPage, searchTerm]);



    const columns = [
        // {
        //     title: "Image",
        //     dataIndex: "imageUrl",
        //     key: "imageUrl",
        //     className: "custom-header",
        //     render: (text) => {
        //         return (
        //             <>
        //                 <p className="font-medium w-[120px]">
        //                     <img src={text} onError={handleErrorImage} crossOrigin="anonymous" />
        //                 </p>
        //             </>
        //         );
        //     },
        // },
        {
            title: "Theme Color",
            dataIndex: "theme_color",
            key: "theme_color",
            className: "custom-header ",
        },
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
            className: "custom-header whitespace-nowrap",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },

        {
            title: "Created Time",
            dataIndex: "register_date",
            key: "register_date",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs">
                            {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            className: "custom-header",
            render: (_, record) => (
                <Popover
                    content={popoverContent(record.id, record.is_active)}
                    trigger="click"
                    placement="bottom"
                >
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: record.is_active == 1 ? "green" : "red",
                            backgroundColor: record.is_active == 1 ? "#e0f5f0" : "#FFE1E1",
                            borderColor: record.is_active == 1 ? "lightgreen" : "pink",
                            borderRadius: "0px",
                            cursor: "pointer",
                        }}
                    >
                        {record.is_active == 1 ? "Active" : "Inactive"}
                    </Tag>
                </Popover>
            ),
        },
    ];
    return (
        <div className="p-4">
            <div className="flex items-end justify-end m-2">
                <Search
                    placeholder="search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "26%" }}
                />
            </div>
            <Card
                title="Brand List"
                // extra={
                //     <Button
                //         type="primary"
                //         icon={<PlusOutlined />}
                //         onClick={() => console.log("Add Order")}
                //         className="rounded"
                //     >
                //         Add Restro
                //     </Button>
                // }
                className="shadow-sm shadow-gray-300"
            >
                <Table
                    title={() => (
                        <div className="flex justify-end">
                            <Button onClick={() => setOpenModal(true)} className="bg-rgbaprimary8 text-white font-semibold rounded-none h-10">
                                {" "}
                                <PlusOutlined /> Add Brand
                            </Button>
                        </div>
                    )}
                    bordered={true}
                    loading={isLoading}
                    columns={columns}
                    dataSource={orderData}
                    pagination={false}
                    className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
                    size="small"
                />
            </Card>
            <Pagination
                className="mt-2 text-xs w-full flex justify-end"
                total={totalPages * 10} // Assuming 10 items per page
                showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${totalPages * 10} items`
                }
                onChange={handlePageChange}
                defaultPageSize={10}
                current={currentPage}
            />
            <Drawer
                title="Add Brand"
                width={400}
                onClose={handleDrawerClose}
                visible={openModal}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleFinish}
                // initialValues={profile}
                >
                    <Form.Item
                        name="title"
                        label="title"
                        rules={[{ required: true, message: "Please enter Restro title" }]}
                    >
                        <Input placeholder="Enter Restro title" />
                    </Form.Item>
                    <Form.Item
                        name="theme_color"
                        label="Theme color (In binary format)"
                        rules={[
                            { required: true, message: "Please enter your Theme color" },
                            { type: "Theme color", message: "Please enter a valid Theme color" },
                        ]}
                    >
                        <Input placeholder="Enter your theme color" />
                    </Form.Item>
                    <Form.Item
                        name={`name`}
                        label={"Select Restro Name"}
                        labelCol={{ span: 24 }}
                        rules={[
                            {
                                required: true,
                                message: "Select one name!",
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            labelInValue={true}
                            onChange={(e) => setVendorId(e.value)}
                            placeholder="Select with restaurant name "
                            filterOption={filterOption}
                            className="w-full mt-2"
                            options={vendorData}
                        />
                    </Form.Item>

                    <Button loading={addloader} type="primary" htmlType="submit" block>
                        Add Restro
                    </Button>
                </Form>
            </Drawer>
        </div>

    );
};
export default Brand;
